define('TescoMobile_Checkout/js/form/billing-address',['Magento_Ui/js/form/components/fieldset', 'ko', 'moment', 'uiRegistry'], function (Component, ko, moment, uiRegistry) {
  'use strict';

  var checkoutConfig = window.checkoutConfig,
    monthField,
    yearField,
    thresholdDays = checkoutConfig.tescomobile.about.previous_address_threshold_days;
  return Component.extend({
    defaults: {
      imports: {
        addressOutsideUk: "${ $.name }.tm_address_outside_uk:checked",
        movedToAddressLessThanConfigThreshold: "${ $.provider }:${ $.customScope }.tm_start_date"
      },
      exports: {
        movedToAddressLessThanConfigThresholdValue: "${ $.name }.tm_address_outside_uk:visible"
      }
    },
    displayPreviousAddress: ko.observable(false),
    movedToAddressLessThanConfigThresholdValue: ko.observable(false),
    tracks: {
      addressOutsideUk: true,
      movedToAddressLessThanConfigThresholdValue: true,
      displayPreviousAddress: true,
      movedToAddressLessThanConfigThreshold: true
    },
    movedToAddressLessThanConfigThreshold: function (startDateField) {
      monthField = uiRegistry.get(this.name + '.tm_start_date.0');
      yearField = uiRegistry.get(this.name + '.tm_start_date.1');
      if (typeof monthField !== 'undefined' && typeof yearField !== 'undefined' && monthField.value() && yearField.value()) {
        if (monthField.validate().valid && yearField.validate().valid) {
          let startDate,
            now = moment();
          startDate = moment(startDateField.year + '-' + startDateField.month + '-' + now.format('DD'), 'YYYY-MM-DD');
          if (now.diff(startDate, 'days') <= thresholdDays) {
            this.movedToAddressLessThanConfigThresholdValue(true);
            this.displayPreviousAddress(true);
            return true;
          }
        }
      }
      this.movedToAddressLessThanConfigThresholdValue(false);
      this.displayPreviousAddress(false);
      return false;
    }
  });
});

